/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_ServicesInputs */



/**
* | output |
* | --- |
* | "services" |
*
* @param {Metrics_ServicesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_services = /** @type {((inputs?: Metrics_ServicesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_ServicesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("services")
});